export const checkContentPlayer = () => {
  const appName = window.location.pathname.split('/')?.[1];
  return appName === 'content-player';
};
